module.exports = __webpack_public_path__ + "static/Privacy-Policy-0fd8f02c991a58f8660c173eff198668.pdf";